'use client'

import { useSiteTheme } from '@/hooks/useSiteTheme'

/**
 * Interruttore chiaro/scuro del **sito**, per chi lo visita.
 *
 * Sta nell'header, non nella console: l'operatore non decide come il pubblico
 * vede il portale. La preferenza è una sola per tutto il sito (`useSiteTheme`).
 */
export function ThemeToggle() {
  const { theme, setTheme } = useSiteTheme()
  const next = theme === 'dark' ? 'light' : 'dark'
  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={next === 'dark' ? 'Passa al tema scuro' : 'Passa al tema chiaro'}
      title={next === 'dark' ? 'Tema scuro' : 'Tema chiaro'}
      aria-pressed={theme === 'dark'}
      className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[color:var(--league-line)] text-[color:var(--league-muted)] transition-colors hover:border-[color:var(--league-brand)] hover:text-[color:var(--league-brand)]"
    >
      {theme === 'dark' ? (
        <svg viewBox="0 0 24 24" aria-hidden className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <path d="M21 12.8A8.5 8.5 0 1111.2 3a7 7 0 009.8 9.8z" />
        </svg>
      )}
    </button>
  )
}

export default ThemeToggle
